// Turn an error from the API into one readable sentence.
// The backend sends either a plain message, or (for invalid input such as a weak
// password) a list of problems — showing that list directly would crash the page.
export function apiErrorMessage(err, fallback) {
  const detail = err.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  // rate limit (too many requests from this computer) — its body has no `detail`
  if (err.response?.status === 429) return 'Too many attempts. Please wait a while and try again.';
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg.replace(/^Value error,\s*/, '');
  return fallback;
}
